import { useEffect, useState } from 'react';
import { api, formatChips, type LeaderRow } from '../api.js';
import { PlayerName } from '../components/PlayerName.js';
import type { LiveState } from '../hooks/useLive.js';

export function LeaderboardPage({ live }: { live: LiveState }) {
  const [rows, setRows] = useState<LeaderRow[]>([]);
  const [founders, setFounders] = useState<Array<{ name: string; at: number }>>([]);

  useEffect(() => {
    void api.leaderboard().then((data) => setRows(data.players)).catch(() => undefined);
    // Founders' Row lives here — the prestige page people actually visit.
    void api
      .accountsDetail<{ founders?: Array<{ name: string; at: number }> }>()
      .then((data) => setFounders(data.founders ?? []))
      .catch(() => undefined);
  }, []);

  // The live socket pushes the board too; prefer whichever is fresher.
  const players = live.leaderboard.length > 0 ? live.leaderboard : rows;

  return (
    <div className="page">
      <header className="page-head">
        <h1>Season standings</h1>
        <p>Ranked by chips held. Everyone starts at 10,000.</p>
      </header>

      {players.length === 0 ? (
        <p className="note">Nobody has a balance yet.</p>
      ) : (
        <ol className="leaderboard">
          {players.map((player) => (
            <li
              key={player.rank}
              className={`${player.rank <= 3 ? 'top' : ''} ${player.style?.spotlight ? 'highlighted' : ''}`}
            >
              <span className="rank num">{player.rank}</span>
              {player.avatarUrl ? <img className="avatar" src={player.avatarUrl} alt="" /> : <span className="avatar blank" />}
              <span className="who">
                <PlayerName name={player.displayName} style={player.style} showTitle />
              </span>
              <span className="chips num">{formatChips(player.balance)}</span>
            </li>
          ))}
        </ol>
      )}

      {founders.length > 0 && (
        <>
          <h2 className="section">Founders&rsquo; Row</h2>
          <ul className="founders">
            {founders.map((founder) => (
              <li key={`${founder.name}-${founder.at}`} className="founder">
                <span className="founder-name">{founder.name}</span>
                <span className="founder-rule" />
                <span className="founder-date">
                  {new Date(founder.at).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
